import React, { Component } from "react";
import { TIMEOUT_AGREMENTS } from "../constants/general";

class AgreementScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreed: false,
    };
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      this.props.handleEnd();
    }, TIMEOUT_AGREMENTS);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  render() {
    const blocks = this.props.text?.split("|||"); // rozdělíme bloky
    const { agreed } = this.state;

    return (
      <div className="App agreements">
        <div className="box-content">
          <div>
            {blocks?.map((block, i) => {
              const lines = block?.split("||"); // první řádek = nadpis
              const [title, ...points] = lines;

              return (
                <div key={i} style={{ marginBottom: "1.5em" }}>
                  <h2 style={{ textAlign: "left" }}>{title}</h2>
                  {points?.map((p, j) => (
                    <p style={{ textAlign: "left" }} key={j}>
                      {p}
                    </p>
                  ))}
                </div>
              );
            })}
          </div>
          <div className="d-flex justify-center">
            <label
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <input
                type="checkbox"
                checked={!!this.state?.agreed}
                onChange={(e) => {
                  this.setState({ agreed: e.target.checked });
                }}
              />
              <span>Souhlasím s podmínkami užití</span>
            </label>
          </div>
          <div className="d-flex justify-center">
            <button
              disabled={!agreed}
              onClick={this.props.handleAcceptAgreements}
              className="btn-continue"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }
}
export default AgreementScreen;
